module.exports = __webpack_public_path__ + "static/media/code.9438a478.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/code.jpg
// module id = 225
// module chunks = 0